<template>
  <viewer @inited="inited" @show="opened">
    <slot />
  </viewer>
</template>

<script>
import 'viewerjs/dist/viewer.css'

// TODO: Hide next/previous buttons when only one image is in the gallery

export default {
  name: 'GalleryItem',
  data() {
    return {
      viewer: null
    }
  },
  methods: {
    // Emit viewer instance to let parent elements use its methods
    inited(viewer) {
      this.viewer = viewer
      this.$emit('inited', viewer)
    },
    // Emit show (=gallery opened) event to parent
    opened() {
      this.$emit('opened', this.viewer)
    }
  }
}
</script>

<style lang="sass">
.viewer-container
  // Let users click through left and right sides of the toolbar, but not through buttons or the navbar
  .viewer-footer
    pointer-events: none
    ul, .viewer-navbar
      pointer-events: auto
</style>
